import { Dispatch, SetStateAction } from 'react';
import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button } from '@mantine/core';

interface Props {
	setIsUploadActive: Dispatch<SetStateAction<boolean>>;
	headerText: string;
}

export const EmptyDocuments = ({ setIsUploadActive, headerText }: Props) => {
	const tCapManage = useTranslationCapManage();
	return (
		<EmptyState
			title={headerText}
			description={tCapManage('document.empty_state.sub_header')}
			icon="es-open-box"
		>
			<Button
				leftSection={<Icon variant="add" size="lg" />}
				onClick={() => setIsUploadActive(true)}
			>
				{tCapManage('document.empty_state.button')}
			</Button>
		</EmptyState>
	);
};
